// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3dDrc","title":"Images45_title__CDSe2","images":"Images45_images__1YaRV"};